<template>
  <router-view/>
</template>


